import { useState } from 'react';
import { DropdownItemsProps } from '../../../ui/components/Dropdown/Dropdown';
import { Modal, ModalBase } from '../../../ui/components/Modal/Modal';
import styles from './AppointmentModalV2.module.scss';
import NewAppointmentIMG from '../../../assets/images/unique/LogoRemastered.png';
import { Heading } from '../../../ui/components/Heading/Heading';
import { Button } from '../../../ui/components/Button';
import { Icon } from '../../../ui/components/Icon';
import { AppointmentModal } from '../AppointmentModal/AppointmentModal';

interface AppointmentModalV2I extends ModalBase {
  defaultService?: DropdownItemsProps;
}

export const AppointmentModalV2 = ({
  isOpen,
  setIsOpen = () => {},
  defaultService,
}: AppointmentModalV2I) => {
  const selectedService = defaultService?.placeholder;
  const [isClassicOpen, setIsClassicOpen] = useState(false);

  const openClassicAppointment = () => {
    setIsOpen(false);
    setIsClassicOpen(true);
  };

  return (
    <>
      <Modal
        colorPalette="doctor-1"
        className={styles.root}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <section className={styles.layout}>
          <div className={styles.media} aria-hidden="true">
            <img
              className={styles.img}
              src={NewAppointmentIMG}
              alt="New appointment system"
            />
            <div className={styles['floating-note']}>
              <Icon type="calendar" alt="" classname={styles['note-icon']} />
              <span>Appointment options</span>
            </div>
          </div>
          <div className={styles.content}>
            <span className={styles.eyebrow}>Book an appointment</span>
            <Heading headingLevel="h2" className={styles.heading}>
              Choose how to request your visit
            </Heading>
            <p className={styles.description}>
              Use the classic request today. The real-time scheduling system is
              planned for a future release.
            </p>
            {selectedService && (
              <div className={styles['service-chip']}>
                <Icon type="medical" alt="" classname={styles['chip-icon']} />
                <span>{selectedService}</span>
              </div>
            )}
            <div className={styles.options}>
              <article className={styles.option}>
                <div className={styles['option-icon']}>
                  <Icon type="whatsapp" alt="" />
                </div>
                <div>
                  <strong>Classic appointment</strong>
                  <p>
                    Fill patient details and send a prepared message to the
                    doctor&apos;s social channel.
                  </p>
                </div>
                <Button
                  btnStyle="secondary"
                  className={`${styles.button} ${styles['classic-button']}`}
                  glassEffect
                  onClick={openClassicAppointment}
                >
                  Start request
                </Button>
              </article>
              <article
                className={`${styles.option} ${styles['disabled-option']}`}
              >
                <div className={styles['option-icon']}>
                  <Icon type="calendar-today" alt="" />
                </div>
                <div>
                  <strong>New appointment system</strong>
                  <p>Real-time scheduling with clinic availability.</p>
                </div>
                <Button
                  btnStyle="secondary"
                  className={`${styles.button} ${styles['online-button']}`}
                  glassEffect
                  isDisabled
                >
                  Coming soon
                </Button>
              </article>
            </div>
          </div>
        </section>
      </Modal>
      <AppointmentModal
        isOpen={isClassicOpen}
        onClose={() => setIsClassicOpen(false)}
        defaultService={defaultService}
      />
    </>
  );
};
